import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { EdlComment } from './../model/comment.model';

@Injectable()
export class CommentApi extends BaseApi {
  constructor(
    @Inject(BASE_URL) private baseUri: string,
    private http: HttpClient
  ) {
    super();
  }

  saveComment(comment: EdlComment) {
    return this.http.post<EdlComment | null | undefined>(this.baseUri + '/comments/save', comment);
  }

  getCommentsForObservation(observationType: number, observationId: string) {
    return this.http.get<EdlComment[]>(this.baseUri + '/comments/' + observationType + '/' + observationId, {});
  }

  deleteComment(comment: EdlComment) {
    return this.http.delete<void>(this.baseUri + '/comments/delete/' + comment.commentID);
  }

  publishAllComments(observationType: number, observationId: string) {
    return this.http.put<string[]>(this.baseUri + '/comments/' + observationType + '/' + observationId + '/publishAll', {});
  }
}
